import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../utils';
import { ZInvitedBySelect } from './models';

const c = initContract();
export const adminReferralContract = c.router(
  {
    getRawInviteesForPlayer: {
      method: 'GET',
      path: '/player/:playerId/invitees',
      pathParams: z.object({
        playerId: z.string(),
      }),
      responses: {
        200: ZInvitedBySelect.extend({
          inviteeFirstName: z.string(),
          inviteeLastName: z.string(),
          referralId: z.string(),
        }).array(),
        400: c.type<{ message: string }>(),
      },
    },
    getRawInvitersForPlayer: {
      method: 'GET',
      path: '/player/:playerId/inviters',
      pathParams: z.object({
        playerId: z.string(),
      }),
      responses: {
        200: ZInvitedBySelect.extend({
          inviterFirstName: z.string(),
          inviterLastName: z.string(),
          referralId: z.string(),
        }).array(),
        400: c.type<{ message: string }>(),
      },
    },
    hasActiveReferralForPlayer: {
      method: 'GET',
      path: '/player/:playerId/referrals/active',
      pathParams: z.object({
        playerId: z.string(),
      }),
      responses: {
        200: z.object({
          hasActiveReferral: z.boolean(),
        }),
        400: c.type<{ message: string }>(),
      },
    },

    applyReferralCodeForPlayer: {
      method: 'POST',
      path: '/player/:playerId/referrals/apply',
      pathParams: z.object({
        playerId: z.string(),
      }),
      body: z.object({
        referralCode: z.string(),
      }),
      responses: {
        200: successSchema,
        400: c.type<{ message: string }>(),
      },
    },
    getReferralStatsForPlayer: {
      method: 'GET',
      path: '/player/:playerId/referrals/stats',
      pathParams: z.object({
        playerId: z.string(),
      }),
      responses: {
        200: z.object({
          count: z.number(),
          maxReferrals: z.number(),
          canReferMore: z.boolean(),
        }),
        400: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/admin',
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  },
);
